<template>
  <div
    ref="pageRef"
    class="nup-page"
    :class="[isPC ? 'is-pc' : 'is-h5', isEn ? 'is-en' : '']"
  >
    <HeroBanner
      :show-enroll="showEnrollBtn"
      :submitting="submitting"
      @enroll="handleEnroll"
      @rules="handleRules"
    />
    <RewardModule
      :show-awarded="showAwarded"
      :show-missed="showMissed"
      :show-countdown="showCountdown"
      :show-choice-btn="showChoiceBtn"
      :show-deposit-btn="showDepositBtn"
      :deposit-end-time="depositEndTime || 0"
      :awarded-images="awardedImages"
      :choice-key="choiceKey || ''"
      :enrolled="isInProgress"
      :net-deposit-amount="netDepositAmount != null ? netDepositAmount : 0"
      @pick="openChoice"
      @deposit="handleDeposit"
      @view-prize="handleViewPrize"
    />
    <StickyCta
      :visible="showSticky && !moduleCtaVisible"
      :text="stickyText"
      :disabled="submitting"
      @click="handleStickyClick"
    />
    <EnrollSuccessDialog
      :visible="successVisible"
      @close="closeSuccess"
      @deposit="onSuccessDeposit"
    />
    <ChoiceConfirmDialog
      :visible="choiceVisible"
      :choice-key="pendingChoiceKey"
      :disabled="submitting"
      @close="closeChoice"
      @confirm="handleUpdateChoice"
    />
    <ChoiceSuccessDialog
      :visible="choiceSuccessVisible"
      :choice-key="choiceKey || ''"
      @close="closeChoiceSuccess"
      @deposit="onChoiceSuccessDeposit"
    />
  </div>
</template>

<script lang="ts">
import { nextTick, ref, watch } from 'vue-demi';
import { useNupLang } from './composables/use-nup-lang';
import { useNupPage } from './composables/use-nup-page';
import { usePageTypeFlag } from './composables/use-page-type';
import { useStickyVisibility } from './composables/use-sticky-visibility';
import ChoiceConfirmDialog from './components/choice-confirm-dialog.vue';
import ChoiceSuccessDialog from './components/choice-success-dialog.vue';
import EnrollSuccessDialog from './components/enroll-success-dialog.vue';
import HeroBanner from './components/hero-banner.vue';
import RewardModule from './components/reward-module.vue';
import StickyCta from './components/sticky-cta.vue';
const __sfc_main = {};
__sfc_main.props = {
  rulesUrl: {
    type: String,
    default: ''
  },
  depositUrl: {
    type: String,
    default: ''
  },
  prizeUrl: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isPC
  } = usePageTypeFlag();
  const {
    isEn
  } = useNupLang();
  const pageRef = ref<HTMLElement | null>(null);
  const {
    submitting,
    choiceKey,
    showCountdown,
    showChoiceBtn,
    showDepositBtn,
    showEnrollBtn,
    showAwarded,
    showMissed,
    showSticky,
    stickyText,
    depositEndTime,
    awardedImages,
    netDepositAmount,
    isInProgress,
    successVisible,
    choiceVisible,
    choiceSuccessVisible,
    pendingChoiceKey,
    handleEnroll,
    handleUpdateChoice,
    handleDeposit,
    handleRules,
    handleViewPrize,
    handleStickyClick,
    openChoice,
    closeSuccess,
    closeChoice,
    closeChoiceSuccess
  } = useNupPage(() => ({
    rulesUrl: props.rulesUrl,
    depositUrl: props.depositUrl,
    prizeUrl: props.prizeUrl
  }));
  function collectCtas(): (Element | null)[] {
    const root = pageRef.value;
    if (!root) {
      return [];
    }
    return Array.prototype.slice.call(root.querySelectorAll('[data-nup-cta]'));
  }
  const {
    moduleCtaVisible,
    rebind
  } = useStickyVisibility(collectCtas);
  watch([showEnrollBtn, showDepositBtn, showAwarded, showMissed], () => {
    nextTick(rebind);
  });
  function onSuccessDeposit(): void {
    closeSuccess();
    handleDeposit();
  }
  function onChoiceSuccessDeposit(): void {
    closeChoiceSuccess();
    handleDeposit();
  }
  return {
    isPC,
    isEn,
    pageRef,
    submitting,
    choiceKey,
    showCountdown,
    showChoiceBtn,
    showDepositBtn,
    showEnrollBtn,
    showAwarded,
    showMissed,
    showSticky,
    stickyText,
    depositEndTime,
    awardedImages,
    netDepositAmount,
    isInProgress,
    successVisible,
    choiceVisible,
    choiceSuccessVisible,
    pendingChoiceKey,
    handleEnroll,
    handleUpdateChoice,
    handleDeposit,
    handleRules,
    handleViewPrize,
    handleStickyClick,
    openChoice,
    closeSuccess,
    closeChoice,
    closeChoiceSuccess,
    moduleCtaVisible,
    onSuccessDeposit,
    onChoiceSuccessDeposit
  };
};
__sfc_main.components = Object.assign({
  HeroBanner,
  RewardModule,
  StickyCta,
  EnrollSuccessDialog,
  ChoiceConfirmDialog,
  ChoiceSuccessDialog
}, __sfc_main.components);
export default __sfc_main;
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

.nup-page {
  width: 100%;
  height: auto !important;
  min-height: 100%;
  overflow: visible;
  overflow-x: hidden;
  background: #f8f7f8;
  font-family: 'PingFang TC', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft JhengHei', sans-serif;
}


.nup-page.is-en {
  font-family: 'SF Pro Text', 'PingFang SC', Helvetica, Arial, sans-serif;
}
</style>
